import React, { Component } from 'react';
import { CommonValidationMessages } from '../../utils/Messages';
import { isValidForm } from '../../utils/validation/CommonValidator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import SwalServices from '../../services/swalServices/SwalServices';
import { Link } from 'react-router-dom';

export default class SetPassword extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.state = {
            isLoading: false,
            showPassword: false,
            showRePassword: false,
            passwordForm: {
                password: "",
                rePassword: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                password: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "password"),
                    },
                ],
                rePassword: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "password"),
                    },
                ],
            },
        };
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.passwordForm,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.passwordForm;
        details[name] = value;
        this.setState({ passwordForm: details });
    };

    togglePasswordVisibility = () => {
        this.setState((prevState) => ({
            showPassword: !prevState.showPassword,
        }));
    };

    toggleRePasswordVisibility = () => {
        this.setState((prevState) => ({
            showRePassword: !prevState.showRePassword,
        }));
    };

    render() {
        return (
            <div className='reset h-screen'>
                <div className='reset-inner flex'>
                    <div className='reset-left flex flex-col justify-between px-[150px] py-[80px] w-[50%]'>
                        <div className='reset-form'>
                            <div className='reset-logo'>
                                <img src='AHG-logo.svg' alt='Arbour Health Group' />
                            </div>
                            <div className='password-sec'>
                                <h1 className='text-[32px] font-medium mb-[10px] text-[#223645]'>Set new password</h1>
                                <p className='text-[16px] font-medium text-[#223645]'>
                                    Your email is verified! Please set a new password for your account.
                                </p>
                                <div className='password-form-inner mt-5'>
                                    <div className='form-group'>
                                        {/* New Password Field */}
                                        <div className='input-grp relative'>
                                            <label>New password:</label>
                                            <input
                                                type={this.state.showPassword ? 'text' : 'password'}
                                                placeholder='Enter your password'
                                                id='password'
                                                name='password'
                                                className={`${this.state.validState?.error?.password ? "error" : ""} pr-10`}
                                                value={this.state.passwordForm.password}
                                                onChange={(event) => this.handleChange(event, "password")}
                                            />
                                            <span
                                                className='absolute right-3 top-[38px] cursor-pointer text-[#223645]'
                                                onClick={this.togglePasswordVisibility}
                                            >
                                                <FontAwesomeIcon icon={this.state.showPassword ? faEyeSlash : faEye} />
                                            </span>
                                        </div>

                                        {/* Re-enter Password Field */}
                                        <div className='input-grp relative !mb-0'>
                                            <label>Re-enter password:</label>
                                            <input
                                                type={this.state.showRePassword ? 'text' : 'password'}
                                                placeholder='Re-enter password'
                                                id='rePassword'
                                                name='rePassword'
                                                className={`${this.state.validState?.error?.rePassword ? "error" : ""} pr-10`}
                                                value={this.state.passwordForm.rePassword}
                                                onChange={(event) => this.handleChange(event, "rePassword")}
                                            />
                                            <span
                                                className='absolute right-3 top-[38px] cursor-pointer text-[#223645]'
                                                onClick={this.toggleRePasswordVisibility}
                                            >
                                                <FontAwesomeIcon icon={this.state.showRePassword ? faEyeSlash : faEye} />
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <button className='prm-btn btn mt-[30px]'>Confirm new password</button>
                                <Link to="/login" className='bg-white border-0 flex items-center gap-[10px] mt-5'>
                                    <FontAwesomeIcon icon={faArrowLeft} className='w-5 h-5' />
                                    Back to login
                                </Link>
                            </div>
                        </div>

                        <div className='copyright'>
                            <p className='text-[10px] font-medium text-[#64748B] text-center'>
                                Copyright 2025. Arbour Healthcare Group All Rights Reserved.
                            </p>
                        </div>
                    </div>

                    <div className='reset-right p-[30px] w-[50%] h-fit'>
                        <div className='reset-right-inner bg-[#0077B6] h-screen relative rounded-t-full' style={{ height: "calc(100vh - 60px)" }}>
                            <img src='tree.svg' alt='Arbour tree' className='w-[90%] h-auto mx-auto absolute bottom-0 right-[5%]' />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
